import { AnimatePresence, motion } from 'motion/react';

import ReturnIcon from '@common/assets/icons/return.svg?react';
import {
  IconButton,
  type IconButtonProps,
} from '@common/ui/buttons/IconButton';

export type BackButtonProps = Omit<IconButtonProps, 'testId'> & {
  visible?: boolean;
};

export const BackButton = ({ visible = true, ...props }: BackButtonProps) => {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.2 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.2 }}
        >
          <IconButton
            testId="back-button"
            size={400}
            variant="actionPrimary"
            {...props}
          >
            <ReturnIcon />
          </IconButton>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
